<div class="app-titulo-pagina">
  <span>Pagamentos em lote</span>
</div>
<!-- Spinner -->
<div *ngIf="mainService.pagamentoService.processando" class="text-center">
  <i class="fa fa-spinner fa-pulse fa-4x"></i>
</div>
<!-- Spinner -->

<div *ngIf="!mainService.pagamentoService.processando">
  <!-- Container instrução boleto em lote -->
  <div *ngIf="!mainService?.pagamentoService?.loteBoletos?.length" class=" container app-panel">
    <div class="panel-body">
      <div class="well col-xs-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2">
        <div style="display: flex; flex-direction: column; align-items: center; ">

          <!-- Container envio de arquivo -->
          <div>
            <h4>Pagamentos em lote</h4>
            <!-- <h3 style="margin-top: 0px;">Instruções de envio</h3> -->
            <label class="app-radio-pagamento">
              <input type="radio" name="tipoEnvioArquivo" [value]="enumTipoEnvio.ARQUIVO" id="inputEnvio"
                [(ngModel)]="tipoEnvio" class="app-nowrap">
              Enviar arquivo
            </label>
            <label>
              <input type="radio" name="tipoLinhaDigitavel" [value]="enumTipoEnvio.LINHA_DIGITAVEL"
                id="inputLinhaDigitavel" [(ngModel)]="tipoEnvio" class="app-nowrap">
              Enviar linhas digitáveis
            </label>

            <div *ngIf="tipoEnvio === enumTipoEnvio.ARQUIVO">
              <!-- Input de envio -->
              <input type="file" (change)="onFileChange($event)" accept=".csv"
                style="margin-top: 10px; margin-bottom: 30px; display: inline;" />
              <!-- Fim Input de envio -->


              <!-- Container instruções de envio -->
              <div style="text-align: left;">
                <p>1. Faça o download da <b> planilha modelo</b> clicando aqui:
                  <a href="assets/downloads/planilha_modelo.csv" download>
                    <i class="fa fa-download fa-lg"></i>
                  </a>
                </p>
                <p>2. Abra a <b>planilha modelo</b> e preencha as linhas digitáveis dos seus pagamentos; </p>
                <p>3. Salve a planilha, clique em <b>Escolher arquivo</b> e envie. </p>
                <p>4. Preencha sua planilha seguindo o exemplo abaixo:</p>
                <img src="assets/img/exemplo_boleto.png" alt="imagem_exemplo" style="margin-top: 10px;">
              </div>
              <!-- Fim Container instruções de envio -->

            </div>

            <div *ngIf="tipoEnvio === enumTipoEnvio.LINHA_DIGITAVEL">
              <!-- button adicionar linha digitável -->
              <button id="adicionar-boleto" type="button" data-toggle="modal" data-target="#input"
                class="btn app-btn-best" style="height: fit-content; margin-top: 15px; margin-left: 20px;">
                <i class="fa fa-plus-circle"></i> Enviar
              </button>
              <!-- Fim button adicionar linha digitável -->

            </div>

          </div>

        </div>
        <!-- Fim Container envio de arquivo -->

      </div>
    </div>
  </div>
  <!-- Fim Container instrução boleto em lote -->

  <!-- Tabela pagamentos enviados -->
  <div *ngIf="mainService.pagamentoService.loteBoletos.length" class="table-responsive"
    style="margin-top: 0px; margin-bottom: 30px;">
    <h4>Pagamentos Enviados:</h4>
    <table class="table table-striped table-hover">

      <thead>
        <tr>
          <th>Linha digitável</th>
          <th>Valor</th>
          <th>Pontos</th>
          <th>Vencimento</th>
          <th>Tipo</th>
          <th>Status</th>
          <th>Descrição</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let boleto of mainService.pagamentoService.loteBoletos">
          <td *ngIf="boleto.status">{{ boleto.barcodeDetails.digitableLine }}</td>
          <td *ngIf="!boleto.status"> <i class="fa fa-spinner fa-pulse fa-2x" style="margin-top: 3px;"></i>
          </td>
          <td>{{boleto?.barcodeDetails.value ? (boleto?.barcodeDetails.value |
            currency:'BRL':'symbol':'1.2-2':'pt'):''}}</td>
          <td>{{boleto?.barcodeDetails.value ? boleto?.valuePoints: ''}}</td>
          <td>{{boleto?.barcodeDetails.dueDate ? (boleto?.barcodeDetails.dueDate |
            dateFormat:'':'dd/MM/yyyy'):(boleto?.status && boleto?.status === enumStatusBoleto.NAO_PAGO ? '-':'')}}</td>
          <td style="white-space: nowrap;">{{boleto?.barcodeDetails?.type ? (boleto?.barcodeDetails?.type ===
            enumTipoBoleto.ARRECADACAO ?
            'Conta Consumo':'Boleto') :''}}</td>
          <td *ngIf="!boleto.status"> <i class="fa fa-spinner fa-pulse fa-2x" style="margin-top: 3px;"></i>
          </td>
          <td *ngIf="boleto.status" style="white-space: nowrap;"> {{boleto?.status.replace('_', '
            ') }}
            <i [ngSwitch]="boleto.status" style="margin-left: 2px;">
              <i *ngSwitchCase="enumStatusBoleto.NAO_PAGO" class="fa fa-check text-success fa-lg"></i>
              <i *ngSwitchDefault class="fa fa-times text-danger fa-lg"></i>
            </i>
          </td>
          <td>
            <div *ngIf="boleto.status && boleto?.status === enumStatusBoleto.NAO_PAGO"
              style="display: flex; flex-direction: column; align-items: center; ">
              <input id="input-obs" type="text" style="width: 16rem;" maxlength="30" class="form-control input-sm"
                [(ngModel)]="boleto.observacao" required>
              <div *ngIf="!boleto.observacao" class="text-danger" style="font-size: 10px;">
                Campo obrigatório
              </div>
            </div>
          </td>

          <td>
            <button *ngIf="boleto?.status" id="excluir-boleto" type="button" (click)="deleteBoleto(boleto)"
              class="btn app-btn-best" style="height: fit-content;">
              <i class="fa fa-times"></i>
              Excluir
            </button>

          </td>
        </tr>

      </tbody>

      <tfoot *ngIf="mainService?.pagamentoService?.requisicoesLoteBoletosConcluidas"
        style="border-top: 1px solid #dddddd; text-align: left;">
        <tr>
          <td colspan="3">
            <button id="adicionar-boleto" type="button" data-toggle="modal" data-target="#input"
              class="btn app-btn-best" style="height: fit-content; margin-top: 15px; margin-left: 20px;">
              <i class="fa fa-plus-circle"></i> Adicionar
            </button>

            <button type="button" class="btn app-btn-best" (click)="deleteBoletosInvalidos()"
              style="height: fit-content; margin-top: 15px; margin-left: 5px;">
              <i class="fa fa-times"></i> Excluir inválidos
            </button>

            <button type="button" class="btn app-btn-best" (click)="deleteBoletos()"
              style="height: fit-content; margin-top: 15px; margin-left: 5px;">
              <i class="fa fa-times"></i> Excluir todos
            </button>
          </td>
          <td colspan="5" style="align-content: center; text-align: end;     padding-right: 2rem;">
            <div>
              <strong>Quantidade de pagamentos:</strong> <span id="valueTotal"
                style="font-size: 1.2em;">{{mainService?.pagamentoService?.loteBoletos?.length }}</span>

            </div>
            <div>
              <strong>Valor total:</strong> <span id="valueTotal"
                style="font-size: 1.2em;">{{mainService?.pagamentoService?.valotTotalBoletosPontos }}</span>
              pontos
            </div>
          </td>

        </tr>
      </tfoot>

    </table>
  </div>
  <!-- Fim Tabela pagamentos enviados -->

  <!-- Container regras e modal adicionar pagamento -->
  <div class="container"
    *ngIf="!mainService.pagamentoService.processando || mainService.pagamentoService.loteBoletos.length > 0">
    <form (submit)="payBoletos()" class="col-xs-12 col-md-12" ngNativeValidate>

      <!-- Modal novo boleto -->
      <div class="modal fade" id="input">
        <div class="modal-dialog" role="document">
          <div class="modal-content col-xs-12">

            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title" id="newLinhaDigitavel">
                <strong>Inserir linha digitável</strong>
              </h4>
            </div>

            <div class="modal-body">
              <span>
                <input class="form-control" style="margin-bottom: 10px;" type="text" name="inputLinhaDigitavel"
                  [(ngModel)]="inputLinhaDigitavel" (keydown.enter)="$event.preventDefault()" />
              </span>

            </div>

            <div class="modal-footer">
              <button type="button" (click)="addBoleto()" data-dismiss="modal" class="btn app-btn-best"
                style="height: fit-content; margin-top: 15px;">
                <i class="fa fa-plus-circle"></i>
                Ok
              </button>

            </div>

          </div>
        </div>
      </div>
      <!-- fim Modal novo boleto -->

      <!-- Texto regras de pagamentos -->
      <div class="col-xs-12 text-left">
        <div class="alert alert-warning" role="alert">
          <br />
          <p><i class="fa fa-exclamation-triangle" aria-hidden="true">
            </i> Horário limite para pagamento em lote é às <strong>16h30</strong>. Pagamentos enviados após esse
            horário
            <strong>não serão aceitos.</strong>
          </p>
          <br />
          <p>
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            Não enviamos comprovantes de pagamentos por email. O mesmo estará
            disponível para impressão após a compensação através da opção
            <strong>extrato</strong>.
          </p>
          <br />
          <p>
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Não
            serão aceitos pagamentos com <strong>juros</strong>.
          </p>
          <br />
          <p>
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> São
            aceitos pagamentos de boletos com <strong>desconto</strong>.
          </p>
          <br />
          <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            São aceitos pagamentos de <strong>conta de consumo, boletos, IPVA, DARF e multas de trânsito</strong>, .
          </p>
          <br>
          <p>
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            <strong>Taxa de Serviço: 0 pontos.</strong>
          </p>
        </div>
        <div class="form-group col-xs-12 col-sm-6 col-md-6 col-md-offset-3 text-center">
          <label for="ep">Senha eletrônica </label>
          <input type="password" id="ep" class="form-control input-sm" name="ep" [(ngModel)]="ep">
        </div>
        <div class="col-xs-12 text-center">
          <a (click)="mainService.loginService.changeRoute('/pagamentos'); deleteBoletos()" id="btn-voltar"
            class="btn btn-danger-v2">
            Voltar
          </a>
          <button id="validar-pagamento" type="submit" class="btn btn-success-v2"
            [disabled]="!mainService?.pagamentoService?.requisicoesLoteBoletosConcluidas">
            Confirmar
          </button>
        </div>
      </div>
      <!-- Fim Texto regras de pagamentos -->
    </form>

  </div>
  <!-- Fim Container regras e modal adicionar pagamento -->
</div>


// WEBPACK FOOTER //
// ./src/app/pagamento/novo-pagamento-lote/novo-pagamento-lote.component.html